<template>
  <InnerCardInfo
    v-if="notesData"
    :label="localStorage.translations.pages['setting-personal_area'].labels['primechanie']"
    :data="notesData"
    ref="inner"
  >
    <template slot="edit_block">
      <slot/>
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'
export default {
  name: 'NotesPfd',
  components: { InnerCardInfo },
  props: ['notes'],
  data: () => ({
    notesData: null,
  }),
  watch: {
    notes() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.notes && this.notes.length > 0) {
        this.notesData = []
        for (let i in this.notes) {
          this.notesData.push({
            value: this.notes[i].text,
          })
        }
      }
    },
  },
}
</script>
